var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Watch, Prop } from "vue-facing-decorator";
import { SystemsClient, ComponentStatusEnum, SortDirection, SortDescription } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import QueryStringHelper from "@/app/utils/querystring-helper";
import 'leaflet.markercluster';
const systemsClient = new SystemsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let StringDashboardVue = class StringDashboardVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.activeTab = 0;
        this.dataLoaded = false;
        this.companyFilter = null;
        this.siteFilter = null;
        this.filteredSystemsUnknown = null;
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SystemName",
            direction: SortDirection.Ascending
        }));
        this.data = new Array();
    }
    created() {
        this.getSystemStatesByString();
    }
    ;
    mounted() {
    }
    ;
    // get
    getSystemStatesByString() {
        if (this.working)
            return;
        this.working = true;
        systemsClient
            .getSystemStatesByString()
            .then(response => {
            this.data = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.dataLoaded = true;
        });
    }
    ;
    goToSnapshot(systemId) {
        // Create a unique key and send as parameter to reload the last snapshot case the page is cached.
        var uniqueKey = Math.floor(new Date().getTime() / 1000).toString();
        this.$router.push({ name: RouteNames.SnapshotForSystem, params: { systemId: systemId.toString(), uniqueKey: uniqueKey } });
    }
    ;
    goToStringSnapshot(systemId, stringId) {
        // Create a unique key and send as parameter to reload the last snapshot case the page is cached.
        var uniqueKey = Math.floor(new Date().getTime() / 1000).toString();
        this.$router.push({ name: RouteNames.SnapshotForString, params: { systemId: systemId.toString(), stringId: stringId.toString(), uniqueKey: uniqueKey } });
    }
    ;
    onSortChanged() {
        var _a, _b, _c, _d;
        let sort = this.sorter.currentSort;
        switch (sort.fieldName) {
            case "StringName":
                this.data.sort((a, b) => {
                    var _a, _b;
                    let stringA = `${(_a = a.stringName) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`;
                    let stringB = `${(_b = b.stringName) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`;
                    if (stringA < stringB)
                        return -1;
                    if (stringA > stringB)
                        return 1;
                    return 0;
                });
                if (sort.direction == SortDirection.Descending)
                    (_a = this.data) === null || _a === void 0 ? void 0 : _a.reverse();
                break;
            case "SystemName":
                this.data.sort((a, b) => {
                    var _a, _b;
                    let systemA = `${(_a = a.systemName) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`;
                    let systemB = `${(_b = b.systemName) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`;
                    if (systemA < systemB)
                        return -1;
                    if (systemA > systemB)
                        return 1;
                    return 0;
                });
                if (sort.direction == SortDirection.Descending)
                    (_b = this.data) === null || _b === void 0 ? void 0 : _b.reverse();
                break;
            case "SiteName":
                this.data.sort((a, b) => {
                    var _a, _b;
                    let systemA = `${(_a = a.siteName) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`;
                    let systemB = `${(_b = b.siteName) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`;
                    if (systemA < systemB)
                        return -1;
                    if (systemA > systemB)
                        return 1;
                    return 0;
                });
                if (sort.direction == SortDirection.Descending)
                    (_c = this.data) === null || _c === void 0 ? void 0 : _c.reverse();
                break;
            case "NumberOfAlarms":
                this.data.sort((a, b) => a.numberOfCriticalAlarmsAck + a.numberOfWarningAlarmsAck + a.numberOfCriticalAlarmsNack + a.numberOfWarningAlarmsNack -
                    (b.numberOfCriticalAlarmsAck + b.numberOfWarningAlarmsAck + b.numberOfCriticalAlarmsNack + b.numberOfWarningAlarmsNack));
                if (sort.direction == SortDirection.Descending)
                    (_d = this.data) === null || _d === void 0 ? void 0 : _d.reverse();
                break;
        }
        ;
    }
    ;
    get visibleStrings() {
        let strings = this.data || [];
        if (!strings.length)
            return [];
        let selectedStatus = this.systemStates.filter(item => item.selected).map(item => item.value.toLowerCase());
        let unknownSelected = selectedStatus.includes("unknown");
        return strings.filter(system => {
            var _a;
            var filtered = selectedStatus.includes((_a = system.statusName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (unknownSelected && system.isSystemOffline);
            if (filtered && this.companyFilter) {
                filtered = system.companyId == this.companyFilter;
            }
            if (filtered && this.siteFilter) {
                filtered = system.siteId == this.siteFilter;
            }
            return filtered;
        });
    }
    hasAlarms(system) {
        return system.numberOfCriticalAlarmsAck + system.numberOfWarningAlarmsAck + system.numberOfCriticalAlarmsNack + system.numberOfWarningAlarmsNack > 0;
    }
    get getFilteredSystemsHealthy() {
        return this.visibleStrings.filter(x => x.statusId == ComponentStatusEnum.Healthy).length;
    }
    get getFilteredSystemsCritical() {
        return this.visibleStrings.filter(x => x.statusId == ComponentStatusEnum.Critical).length;
    }
    get getFilteredSystemsWarning() {
        return this.visibleStrings.filter(x => x.statusId == ComponentStatusEnum.Warning).length;
    }
    get getFilteredAckCriticalAlarms() {
        var count = 0;
        this.visibleStrings.forEach(system => {
            count += system.numberOfCriticalAlarmsAck;
        });
        return count;
    }
    get getFilteredNackCriticalAlarms() {
        var count = 0;
        this.visibleStrings.forEach(system => {
            count += system.numberOfCriticalAlarmsNack;
        });
        return count;
    }
    get getFilteredAckWarningAlarms() {
        var count = 0;
        this.visibleStrings.forEach(system => {
            count += system.numberOfWarningAlarmsAck;
        });
        return count;
    }
    get getFilteredNackWarningAlarms() {
        var count = 0;
        this.visibleStrings.forEach(system => {
            count += system.numberOfWarningAlarmsNack;
        });
        return count;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
], StringDashboardVue.prototype, "systemStates", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], StringDashboardVue.prototype, "companyFilter", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], StringDashboardVue.prototype, "siteFilter", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], StringDashboardVue.prototype, "filteredSystemsUnknown", void 0);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringDashboardVue.prototype, "onSortChanged", null);
StringDashboardVue = __decorate([
    Component({
        name: "StringDashboardVue",
        components: {},
    })
], StringDashboardVue);
export default StringDashboardVue;
